import { action, makeObservable, observable } from "mobx";
import ImpactsApi from "../../../../../../../../services/api/v2/impacts/Impacts.api";
import AudiencesApi from "../../../../../../../../services/api/v2/audiences/Audiences.api";
import ModalContext from "../../../../../../../modalZ/context/ModalContext";

export class AudienceImpactsModalModel {
  organisationId: number;
  projectId: number;
  @observable isLoading: boolean = true;
  @observable data: FP.Entities.IImpactSummary[] = [];
  impactsProvider = ImpactsApi;
  audiencesProvider = AudiencesApi;
  @observable selectedLinkItemsIds: number[] = [];
  @observable selectedItemIds: number[] = [];
  /**
   *
   */
  constructor(organisationId: number, projectId: number, selectedItemIds: number[], selectedLinkItemsIds: number[]) {
    makeObservable(this);
    this.organisationId = organisationId;
    this.projectId = projectId;
    this.selectedLinkItemsIds = selectedLinkItemsIds;
    this.selectedItemIds = selectedItemIds;
  }

  onMount = async () => {
    await this.loadImpacts();
  };

  loadImpacts = async () => {
    let res = await this.impactsProvider.getGridData(this.organisationId, this.projectId);

    if (res.isError) return;

    this.setData(res.payload.data);
    this.setIsLoading(false);
  };

  @action
  setData = (data: FP.Entities.IImpactSummary[]) => {
    this.data = data.map(e => {
      return {
        ...e,
        audiences: JSON.parse(e.audiences)
      };
    });
  };

  @action
  setIsLoading = (isLoading: boolean) => (this.isLoading = isLoading);

  @action
  onAssignSuccess = async (selectedItemIds: number[]) => {
    await this.audiencesProvider.addBulkImpactsToAudiences(
      this.organisationId,
      this.projectId,
      this.selectedLinkItemsIds,
      selectedItemIds
    );
    ModalContext.hide();
  };
}
